// extracted by mini-css-extract-plugin
export var contactUs = "Footer-module--contact-us--e3185";
export var ctaContainer = "Footer-module--cta-container--07184";
export var followUs = "Footer-module--follow-us--c5852";
export var footer = "Footer-module--footer--2d913";
export var footerBoxes = "Footer-module--footer-boxes--0ff61";
export var footerLeft = "Footer-module--footer-left--e0f60";
export var footerLight = "Footer-module--footer-light--dccbb";
export var footerNavs = "Footer-module--footer-navs--4396c";
export var mainFooter = "Footer-module--main-footer--d6117";
export var subFooter = "Footer-module--sub-footer--16040";
export var subscribe = "Footer-module--subscribe--f7ce9";